/**
 * External Dependencies
 */
import 'jquery';

import Router from './util/Router';
import domReady from "./util/domReady";

import common from './routes/common';
import home from './routes/home';
import singleProduct from './routes/single-product';
import productList from './routes/product-list';
import pageWishlist from './routes/page-wishlist';
import compareCategory from './routes/compare-category';
import pageCompare from './routes/page-compare';
import withLoadCard from './routes/with-load-card';
import cart from './routes/cart';
import productSearch from './routes/product-search';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
    common,
    home,
    singleProduct,
    productList,
    pageWishlist,
    cart,
    withLoadCard,
    compareCategory,
    pageCompare,
    productSearch,
});

domReady(() => {
    routes.loadEvents();
});
